import React, { useState } from 'react';
import { FaCog, FaClock, FaGraduationCap, FaPalette } from 'react-icons/fa';
import './flashcard_preferences.css';

function FlashcardPreferences({ isDarkMode }) {
  // # Study preferences
  const [cardsPerSession, setCardsPerSession] = useState(20);
  const [newCardsPerDay, setNewCardsPerDay] = useState(10);
  const [reviewsPerDay, setReviewsPerDay] = useState(50);

  // # Timer preferences
  const [showTimer, setShowTimer] = useState(true);
  const [defaultTimeLimit, setDefaultTimeLimit] = useState(60);
  const [autoAdvance, setAutoAdvance] = useState(false);

  // # Display preferences
  const [fontSize, setFontSize] = useState('medium');
  const [showImages, setShowImages] = useState(true);
  const [highlightKeywords, setHighlightKeywords] = useState(true);

  // # Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Save preferences to backend
  };

  return (
    <div className="flsh_pref_content">
      <form onSubmit={handleSubmit}>
        {/* Study Settings */}
        <div className="flsh_pref_section">
          <div className="flsh_pref_header">
            <FaGraduationCap />
            <h3>Study Settings</h3>
          </div>
          
          <div className="flsh_pref_group">
            <label>
              Cards per study session:
              <input
                type="number"
                min="1"
                max="100"
                value={cardsPerSession}
                onChange={(e) => setCardsPerSession(Number(e.target.value))}
              />
            </label>

            <label>
              New cards per day:
              <input
                type="number"
                min="0"
                max="50"
                value={newCardsPerDay}
                onChange={(e) => setNewCardsPerDay(Number(e.target.value))}
              />
            </label>

            <label>
              Reviews per day:
              <input
                type="number"
                min="0"
                max="200"
                value={reviewsPerDay}
                onChange={(e) => setReviewsPerDay(Number(e.target.value))}
              />
            </label>
          </div>
        </div>

        {/* Timer Settings */}
        <div className="flsh_pref_section">
          <div className="flsh_pref_header">
            <FaClock />
            <h3>Timer Settings</h3>
          </div>
          
          <div className="flsh_pref_group">
            <label className="flsh_pref_checkbox-label">
              <input
                type="checkbox"
                checked={showTimer}
                onChange={(e) => setShowTimer(e.target.checked)}
              />
              Show timer during review
            </label>

            <label>
              Default time limit (seconds):
              <input
                type="number"
                min="5"
                max="300"
                value={defaultTimeLimit}
                onChange={(e) => setDefaultTimeLimit(Number(e.target.value))}
                disabled={!showTimer}
              />
            </label>

            <label className="flsh_pref_checkbox-label">
              <input
                type="checkbox"
                checked={autoAdvance}
                onChange={(e) => setAutoAdvance(e.target.checked)}
                disabled={!showTimer}
              />
              Auto-advance when time expires
            </label>
          </div>
        </div>

        {/* Display Settings */}
        <div className="flsh_pref_section">
          <div className="flsh_pref_header">
            <FaPalette />
            <h3>Display Settings</h3>
          </div>
          
          <div className="flsh_pref_group">
            <label>
              Font size:
              <select
                value={fontSize}
                onChange={(e) => setFontSize(e.target.value)}
              >
                <option value="small">Small</option>
                <option value="medium">Medium</option>
                <option value="large">Large</option>
              </select>
            </label>

            <label className="flsh_pref_checkbox-label">
              <input
                type="checkbox"
                checked={showImages}
                onChange={(e) => setShowImages(e.target.checked)}
              />
              Show images in cards
            </label>

            <label className="flsh_pref_checkbox-label">
              <input
                type="checkbox"
                checked={highlightKeywords}
                onChange={(e) => setHighlightKeywords(e.target.checked)}
              />
              Highlight keywords
            </label>
          </div>
        </div>

        {/* Save Button */}
        <div className="flsh_pref_actions">
          <button type="submit" className="flsh_pref_save-button">
            <FaCog />
            Save Preferences
          </button>
        </div>
      </form>
    </div>
  );
}

export default FlashcardPreferences; 